import { enrichBreadcrumbsWithDataHooks } from './enrichBreadcrumbsWithDataHooks';
import { calculateAppEnvironment } from './calculateAppEnvironment';
export function prepareOptions(options) {
    const { dsn, appName = '', version, environment, beforeSend, transport, integrations, artifactId, wixRecorder, } = options;
    return Object.assign(Object.assign({ dsn, environment: environment || calculateAppEnvironment() }, (version && { release: `${artifactId !== null && artifactId !== void 0 ? artifactId : appName}@${version}` })), { beforeBreadcrumb: enrichBreadcrumbsWithDataHooks, beforeSend: async (event, hint) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            let newEvent;
            const originalFingerprint = event.fingerprint;
            const isBeforeSendExists = !!beforeSend;
            if (isBeforeSendExists) {
                event.tags = Object.assign(Object.assign({}, event.tags), { customBeforeSend: true });
            }
            try {
                newEvent = isBeforeSendExists
                    ? (await beforeSend(event, hint))
                    : event;
            }
            catch (e) {
                // should add BI here!
                event.contexts = Object.assign(Object.assign({}, event.contexts), { errorMonitorBuiltInContext: Object.assign(Object.assign({}, (_a = event.contexts) === null || _a === void 0 ? void 0 : _a.errorMonitorBuiltInContext), { customBeforeSendError: true }) });
                newEvent = event;
            }
            if (!newEvent) {
                event.fingerprint = originalFingerprint;
                event.contexts = Object.assign(Object.assign({}, event.contexts), { errorMonitorBuiltInContext: Object.assign(Object.assign({}, (_b = event.contexts) === null || _b === void 0 ? void 0 : _b.errorMonitorBuiltInContext), { customBeforeSendReturnNull: true }) });
                event.environment = 'unknown';
                return event;
            }
            newEvent.fingerprint = originalFingerprint;
            const availableStacktraces = [
                ...((_e = (_d = (_c = newEvent.exception) === null || _c === void 0 ? void 0 : _c.values) === null || _d === void 0 ? void 0 : _d.map((error) => error.stacktrace)) !== null && _e !== void 0 ? _e : []),
                newEvent.stacktrace,
            ];
            const stackTraceArtifactIds = availableStacktraces.flatMap((stacktrace) => extractArtifactIdsFromStacktrace(stacktrace));
            // extracting artifactId from the url error
            // in case of a fetch call to an artifact parastorage link and it fails
            const urlArtifactId = extractArtifactIdFromParastoragePath([
                (_h = (_g = (_f = newEvent.contexts) === null || _f === void 0 ? void 0 : _f.httpErrorDetails) === null || _g === void 0 ? void 0 : _g.requestConfig) === null || _h === void 0 ? void 0 : _h.url,
            ]);
            const detectedArtifactIds = Array.from(new Set([...stackTraceArtifactIds, ...urlArtifactId]));
            if (artifactId &&
                !detectedArtifactIds.includes(artifactId) &&
                newEvent.environment === 'production') {
                newEvent.environment = 'unknown';
            }
            newEvent.contexts = Object.assign(Object.assign({}, newEvent.contexts), { errorMonitorBuiltInContext: Object.assign(Object.assign({}, (_j = newEvent.contexts) === null || _j === void 0 ? void 0 : _j.errorMonitorBuiltInContext), { detectedArtifactIds }) });
            const sessionRecordingUrl = await (wixRecorder === null || wixRecorder === void 0 ? void 0 : wixRecorder.recordUrl());
            if (sessionRecordingUrl) {
                newEvent.tags = Object.assign(Object.assign({}, newEvent.tags), { sessionRecordingUrl });
                if (sessionRecordingUrl.startsWith('https://app.fullstory.com')) {
                    /**
                     * Set fullStory url into the same context, where official "sentry-fullstory" integration is putting it
                     * Need to verify, but looks like this will help with enabling Fullstory integration from Sentry UI side
                     * https://github.com/getsentry/sentry-fullstory/blob/master/src/SentryFullStory.ts#L73
                     */
                    newEvent.contexts = Object.assign(Object.assign({}, newEvent.contexts), { fullStory: {
                            fullStoryUrl: sessionRecordingUrl,
                        } });
                }
                else {
                    newEvent.contexts = Object.assign(Object.assign({}, newEvent.contexts), { errorMonitorBuiltInContext: Object.assign(Object.assign({}, (_k = newEvent.contexts) === null || _k === void 0 ? void 0 : _k.errorMonitorBuiltInContext), { sessionRecordingUrl }) });
                }
            }
            return newEvent;
        }, transport,
        integrations });
}
const extractArtifactIdsFromStacktrace = (stacktrace) => {
    var _a;
    const frames = (_a = stacktrace === null || stacktrace === void 0 ? void 0 : stacktrace.frames) !== null && _a !== void 0 ? _a : [];
    const allFileNamesFromStack = frames
        .map((frame) => frame.abs_path || frame.filename)
        .filter((path) => !!path)
        .reverse();
    return extractArtifactIdFromParastoragePath(allFileNamesFromStack);
};
const extractArtifactIdFromParastoragePath = (paths) => {
    const parastorageRegex = /(?:\/services|\/_partials)\/([^/]*)\/((?:0|[1-9]\d*)\.(?:0|[1-9]\d*)\.(?:0|[1-9]\d*)|[a-f0-9]{56})\//i;
    return paths === null || paths === void 0 ? void 0 : paths.map((fileName) => parastorageRegex.exec(fileName !== null && fileName !== void 0 ? fileName : '')).filter((matches) => !!matches).map((matches) => matches[1]);
};
//# sourceMappingURL=prepareOptions.js.map